(ns common.widgets.inline-edit
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/ClickAwayListener$default" :as ClickAwayListener]
            ["@mui/material/Grow$default" :as Grow]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["react" :as react]
            ["react-use/lib/component/UseKey$default" :as UseKey]
            [common.util :refer [spread-obj]]
            [uix.core :refer [$ defui]]))

;; Later the buttons might follow the design by default (more closely?) and
;; this is (partially) unnecessary. The box-shadow might be specific to this
;; component.
(def odsIconButton
  #js {:border 1
       :p 0.5
       :borderRadius "4px"
       :borderColor "grey.300"
       :color "text.primary"
       :boxShadow "3px 3px 7px rgba(0, 0, 0, 0.15)"})

;; FIXME: Enter to save, local state is lost but focus is kept -> edit field doesn't work.
(defui inline-edit-text-field
  "Interactions:
  - on hover the input has border, to indicate it can be activated
  - click to activate the input will initialize local state
  - accept and cancel buttons
    - accept btn always calls on-accept fn
  - input loses focus (click away listener) ->
    accept if there are changes, cancel if no changes so we don't send extra
    request to the backend.
  - enter -> form on submit, accept the value, keeps the focus on input
    and shows the new saved value on the input.
  - esc -> cancel the change
  - If on-accept fn returns a promise, the component waits until the
    promise is resolved before the local state is cleaned. If the
    promise is rejected, e.g. backend error on save, the input
    stays active, but component user should handle displaying the error."
  [{:keys [value text-field-props on-accept]}]
  (let [[^js anchor-el set-anchor-el] (react/useState nil)
        open (boolean anchor-el)
        [local-value set-local-value] (react/useState value)
        accept (fn [_e clear-focus]
                 (-> (js/Promise.resolve (on-accept local-value))
                     (.then (fn [_]
                              (set-local-value nil)
                              (when clear-focus
                                (set-anchor-el nil))))
                     (.catch (fn [_]))))
        close (fn [_e]
                (set-local-value nil)
                (set-anchor-el nil))]
    ($ ClickAwayListener
       {:onClickAway (fn [e]
                       (if (and (not= local-value value)
                                (seq local-value))
                         (accept e true)
                         (close e)))}
       ($ Box
          {:component "form"
           :sx #js {:width "100%"
                    :position "relative"}
           :onSubmit (fn [e]
                       (.preventDefault e)
                       (accept e false))}
          ($ TextField
             (assoc text-field-props
                    :sx #js {:width "100%"
                             ".MuiOutlinedInput-notchedOutline" #js {:transition "border-color linear"
                                                                     :transitionDuration (fn [^js theme] (str (.. theme -transitions -duration -enteringScreen) "ms"))
                                                                     :borderColor (when-not open "transparent")}}
                    ;; If local-value is cleared by accept fn from on-submit,
                    ;; but the focus is kept on the input, local-value is empty
                    ;; but we want to show the latest value.
                    :value (if open
                             (or local-value value "")
                             value)
                    :onChange (fn [e]
                                (set-local-value (.-value (.-target e))))
                    :inputProps (spread-obj (:inputProps text-field-props)
                                            #js {:onFocus (fn [e]
                                                            (when-not open
                                                              (set-local-value value)
                                                              (set-anchor-el (.-currentTarget e))))})))
          (when open
            ($ UseKey
               {:filter "Escape"
                :fn (fn [e]
                      ;; Reset local state
                      (close e)
                      ;; Remove focus from the input - because esc doesn't do that by itself
                      (.blur anchor-el))}))
          ;; TODO: Fix this, it doesn't work
          ($ Grow
             {:in open
              :position "absolute"
              :top "100%"
              :right 0}
             ($ Stack
                {:sx #js {:pt 0.5}
                 :direction "row"
                 :spacing 1}
                ($ IconButton
                   {:type "submit"
                    :sx odsIconButton
                    :data-testid "checkButton"
                    :disabled (empty? local-value)}
                   ($ Icon "check"))
                ($ IconButton
                   {:sx odsIconButton
                    :onClick close}
                   ($ Icon "close"))))))))
